import { Store } from 'vuex';

let callBack: Function = () => {};
export const executeCallBack = () => {
  return callBack();
};

export const isNeedNewPdpConsent = (store: Store<any>) => {
  return store.state?.user?.profile?.is_need_consent_new_pdp;
};

export const openNewPdpConsentModal = (store: Store<any>) => {
  store.commit('setNewPdpConsentModalVisible', true);
};

export const blockByNewPdpConsent = (
  store: Store<any>,
  _callBack: Function
) => {
  const needNewConsent = isNeedNewPdpConsent(store);
  if (!needNewConsent) return false;
  callBack = _callBack;
  openNewPdpConsentModal(store);
  return true;
};



// WEBPACK FOOTER //
// ./src/tools/newPdpConsentGuard.ts